import { ApplicationConfig } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { commonProviders, provideTitleStrategy } from '@workspace/ng-aura';
import { provideEtxeAuthLayoutConfig } from '@workspace/ng-etxe-features';
import { provideAppInitialization } from './app.initialization';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitialization,
    provideRouter(routes, withComponentInputBinding()),
    ...commonProviders,
    provideTitleStrategy({
      separator: '|',
      trailing: 'ETXE - Admin',
    }),
    provideEtxeAuthLayoutConfig(),
  ],
};
